import { useReducer } from "react"

export function requestReducer(state, { type, payload }) {
  switch (type) {
    case "FETCH":
      return { ...state, status: "loading" }
    case "RESOLVE":
      return { ...state, data: payload, status: "success" }
    case "EMPTY":
      return { ...state, status: "empty" }
    case "REJECT":
      return { ...state, error: payload, status: "failed" }
    case "DISCONNECT":
      return { ...state, status: "idle" }
    default:
      return state
  }
}

/**
 * Get a default request reducer to track states
 * USAGE:
 * const [state, dispatch] = useRequestReducer({ data: undefined })
 * dispatch({ type: "FETCH" }) // state transitions: idle => loading
 * asyncEvent.then(res => { dispatch({ type: "RESOLVE", payload: res }) }) // loading => success
 * asyncEvent.then(res => { res.length == 0 && dispatch({ type: "EMPTY"}) }) // loading => empty
 * asyncEvent.catch(err => { dispatch({ type: "REJECT", payload: err }) }) // loading => failed
 *
 * For a pictoral view of the actions and state flow. See:
 * https://gist.github.com/josephrexme/1c6d7d94c07bdcb8e24e7513cd2ca917
 * @param {object} initialState
 */
export function useRequestReducer(initialState) {
  const defaultState = {
    data: [],
    error: null,
    status: "idle",
    ...initialState
  }
  const [state, dispatch] = useReducer(requestReducer, defaultState)
  return [state, dispatch]
}
